module.exports = __webpack_public_path__ + "static/media/stand-w-crypto.2d2764c9.jpeg";